import { render, staticRenderFns } from "./PosterInfo.vue?vue&type=template&id=377e59e8&scoped=true&"
import script from "./PosterInfo.vue?vue&type=script&lang=js&"
export * from "./PosterInfo.vue?vue&type=script&lang=js&"
import style0 from "./PosterInfo.vue?vue&type=style&index=0&id=377e59e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e59e8",
  null
  
)

export default component.exports